import React, { Component } from "react";
import { Row, Col, Button, Alert, Container, Label, Input, FormGroup, Card, CardBody } from "reactstrap";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";

// Redux
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

// import images
import logodark from "../../assets/images/my-logo.png";
import logolight from "../../assets/images/my-logo.png";

// Actions
import { registerUser, registerUserFailed, apiError } from '../../store/actions';

// Validation Schema
const RegisterSchema = Yup.object().shape({
    email: Yup.string('Invalid email address'),
    name: Yup.string()
        .min(3, 'Username must be at least 3 characters')
        .required('Username is required'),
    password: Yup.string()
        .min(6, 'Password must be at least 6 characters')
        .required('Password is required')
});

class Register extends Component {
    componentDidMount() {
        this.props.registerUserFailed("");
        this.props.apiError("");
        document.body.classList.add("auth-body-bg");
    }

    componentWillUnmount() {
        document.body.classList.remove("auth-body-bg");
    }

    render() {
        return (
            <RegisterForm
                user={this.props.user}
                registrationError={this.props.registrationError}
                loading={this.props.loading}
                onRegisterUser={this.props.registerUser}
            />
        );
    }
}

function RegisterForm({ user, registrationError, loading, onRegisterUser }) {
    const navigate = useNavigate();
    const initialValues = {
        email: "",
        name: "",
        password: "",
        role: "admin"
    };

    const handleSubmit = (values, { setSubmitting }) => {
        onRegisterUser(values, navigate);
        setSubmitting(false);
    };

    return (
        <div>
            <Container className="d-flex align-items-center justify-content-center min-vh-100">
                <Row className="w-100 justify-content-center">
                    <Col md={8} lg={6} xl={6}>
                        <Card className="shadow-sm">
                            <CardBody className="p-4">
                                <div className="text-center">
                                    <Link to="/" className="">
                                        <img src={logodark} alt="" width="75" className="auth-logo logo-dark mx-auto" />
                                        <img src={logolight} alt="" width="75" className="auth-logo logo-light mx-auto" />
                                    </Link>
                                    <h4 className="font-size-18 mt-4">Register account</h4>
                                    <p className="text-muted">Get your free Namaste World Tour account now.</p>
                                </div>

                                {user && <Alert color="success">Registration Done Successfully.</Alert>}
                                {registrationError && <Alert color="danger">{registrationError}</Alert>}

                                <div className="p-2 mt-4">
                                    <Formik
                                        initialValues={initialValues}
                                        validationSchema={RegisterSchema}
                                        onSubmit={handleSubmit}
                                    >
                                        {({ errors, touched, isSubmitting }) => (
                                            <Form className="form-horizontal">
                                                <FormGroup className="auth-form-group-custom mb-4">
                                                    <i className="ri-user-2-line auti-custom-input-icon"></i>
                                                    <Label htmlFor="email">Email</Label>
                                                    <Field
                                                        name="email"
                                                        as={Input}
                                                        type="text"
                                                        className={`form-control ${errors.email && touched.email ? 'is-invalid' : ''}`}
                                                        id="email"
                                                        placeholder="Enter email"
                                                    />
                                                    <ErrorMessage name="email" component="div" className="invalid-feedback" />
                                                </FormGroup>
                                                <FormGroup className="auth-form-group-custom mb-4">
                                                    <i className="ri-user-2-line auti-custom-input-icon"></i>
                                                    <Label htmlFor="name">Username</Label>
                                                    <Field
                                                        name="name"
                                                        as={Input}
                                                        type="text"
                                                        className={`form-control ${errors.name && touched.name ? 'is-invalid' : ''}`}
                                                        id="username"
                                                        placeholder="Enter username"
                                                    />
                                                    <ErrorMessage name="name" component="div" className="invalid-feedback" />
                                                </FormGroup>

                                                <FormGroup className="auth-form-group-custom mb-4">
                                                    <i className="ri-lock-2-line auti-custom-input-icon"></i>
                                                    <Label htmlFor="password">Password</Label>
                                                    <Field
                                                        name="password"
                                                        as={Input}
                                                        type="password"
                                                        className={`form-control ${errors.password && touched.password ? 'is-invalid' : ''}`}
                                                        id="password"
                                                        placeholder="Enter password"
                                                    />
                                                    <ErrorMessage name="password" component="div" className="invalid-feedback" />
                                                </FormGroup>

                                                {/* Hidden role field */}
                                                <Field type="hidden" name="role" />

                                                <div className="text-center">
                                                    <Button
                                                        color="primary"
                                                        className="w-md waves-effect waves-light"
                                                        type="submit"
                                                        disabled={isSubmitting || loading}
                                                    >
                                                        {loading ? "Loading ..." : "Register"}
                                                    </Button>
                                                </div>

                                                <div className="mt-4 text-center">
                                                    <p className="mb-0">By registering you agree to the Namaste World Tour <Link to="#" className="text-primary">Terms of Use</Link></p>
                                                </div>
                                            </Form>
                                        )}
                                    </Formik>
                                </div>

                                <div className="mt-4 text-center">
                                    <p>Already have an account? <Link to="/login" className="fw-medium text-primary"> Login</Link></p>
                                    <p>© 2025 Namaste World Tour.</p>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

const mapStatetoProps = state => {
    const { user, registrationError, loading } = state.Account;
    return { user, registrationError, loading };
}

export default connect(mapStatetoProps, { registerUser, apiError, registerUserFailed })(Register);